import { render, staticRenderFns } from "./ProjectManager.vue?vue&type=template&id=38197798&scoped=true"
import script from "./ProjectManager.vue?vue&type=script&lang=js"
export * from "./ProjectManager.vue?vue&type=script&lang=js"
import style0 from "./ProjectManager.vue?vue&type=style&index=0&id=38197798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38197798",
  null
  
)

export default component.exports